import React from "react";

const SecureFileSearchBar = ({ value, onChange, filteredCount, totalCount }) => (
  <div className="secure-file-search level mb-3">
    <div className="level-left">
      <div className="level-item secure-file-search-field">
        <input
          className="input is-small secure-file-search-input"
          type="search"
          placeholder="Search by file name, uploader, status, or upload date..."
          value={value}
          onChange={(event) => onChange(event.target.value)}
          aria-label="Search secure files"
        />
      </div>
    </div>
    {value.trim() && (
      <div className="level-right">
        <div className="level-item">
          <p className="is-size-7 has-text-grey mb-0">
            Showing {filteredCount} of {totalCount}
          </p>
        </div>
      </div>
    )}
  </div>
);

export default SecureFileSearchBar;
